function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { init as initSentry } from "@sentry/browser";
import { Integrations as TracingIntegrations } from "@sentry/tracing";
const withSentry = sentryConfigs => {
  if (process.browser && sentryConfigs && sentryConfigs.enabled && sentryConfigs.dsn) {
    initSentry(_extends({}, sentryConfigs, {
      integrations: [new TracingIntegrations.BrowserTracing()],
      tracesSampleRate: sentryConfigs.tracesSampleRate || 0.2,
      release: process.env.GIT_SHA
    }));
  } else if (process.browser && !sentryConfigs) {
    console.warn("No sentry config is set");
  }
  return App => {
    return App;
  };
};
export default withSentry;